import React from 'react'
import styled from 'styled-components'
import {
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Container,
  Row,
  Col,
  Button,
} from 'reactstrap'
import get from 'lodash/get'
import { selectColor } from '../../function'
import { FONTS, COLORS } from '../../constants'

export const Compensate = (props) => {
  const open = get(props, 'open')
  const toggle = get(props, 'toggle')
  const handleRemark = get(props, 'handleRemark')
  return (
    <Modal
      isOpen={ open }
      toggle={ () => toggle() }
    >
      <ModalHeader toggle={ () => toggle() }>
        <Header>
          Compensate Work Request Information
        </Header>
      </ModalHeader>
      <ModalBody>
        <Container>
          <Row>
            <Col>
              <LabelTextInfo>Employee Name</LabelTextInfo>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInfo>
                { get(props, 'myInbox.name') }
              </TextInfo>
            </Col>
          </Row>
          <LabelTextInfo>Compensate Date</LabelTextInfo>
          <Row>
            <Col>
              <TextInfo>
                { get(props, 'myInbox.start_date') } - { get(props, 'myInbox.end_date') }
              </TextInfo>
            </Col>
          </Row>
          <Row>
            <Col>
              <LabelTextInfo>Working Time</LabelTextInfo>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInfo>
                { get(props, 'myInbox.working_time') }
              </TextInfo>
            </Col>
          </Row>
          <Row>
            <Col>
              <LabelTextInfo>Approver</LabelTextInfo>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInfo>
                { get(props, 'myInbox.approver') }
              </TextInfo>
            </Col>
          </Row>
          { get(props, 'myInbox.attachment_url', '') !== '' &&
            <div>
              <Row>
                <Col>
                  <LabelTextInfo>Attachments</LabelTextInfo>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button
                    color="info"
                    onClick={ () => window.open(get(props, 'myInbox.attachment_url'), 'blank') }
                  >Download</Button>
                </Col>
              </Row>
            </div>
          }
          { get(props, 'myInbox.status', '') !== '' &&
            <div>
              <Row>
                <Col>
                  <LabelTextInfo>Status</LabelTextInfo>
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextInfo style={ { color: selectColor(get(props, 'myInbox.status')) } }>
                    { get(props, 'myInbox.status') }
                  </TextInfo>
                </Col>
              </Row>
            </div>
          }
          { get(props, 'myInbox.remark_request_user', '') !== '' &&
            <div>
              <Row>
                <Col>
                  <LabelTextInfo>Remarks</LabelTextInfo>
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextInfo>
                    { get(props, 'myInbox.remark_request_user') }
                  </TextInfo>
                </Col>
              </Row>
            </div>
          }
          { get(props, 'myInbox.remark_approver', '') !== '' &&
            <div>
              <Row>
                <Col>
                  <LabelTextInfo>Approver Remarks</LabelTextInfo>
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextInfo>
                    { get(props, 'myInbox.remark_approver') }
                  </TextInfo>
                </Col>
              </Row>
            </div>
          }
          { get(props, 'myInbox.remark_hr', '') !== '' &&
            <div>
              <Row>
                <Col>
                  <LabelTextInfo>HR Remarks</LabelTextInfo>
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextInfo>
                    { get(props, 'myInbox.remark_hr') }
                  </TextInfo>
                </Col>
              </Row>
            </div>
          }
          { get(props, 'myInbox.remark_cancel', '') !== '' &&
            <div>
              <Row>
                <Col>
                  <LabelTextInfo>Cancel Remarks</LabelTextInfo>
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextInfo>
                    { get(props, 'myInbox.remark_cancel') }
                  </TextInfo>
                </Col>
              </Row>
            </div>
          }
          { get(props, 'myInbox.status', '') === 'PENDING' &&
            <div>
              <DropdownItem divider />
              <LabelTextInfo>Remarks (Optional)</LabelTextInfo>
              <textarea
                style={ { marginBottom: '5px' } }
                className="form-control rounded-0"
                rows="3"
                onBlur={ (e) => handleRemark(e) }
              />
              { get(props, 'button') }
            </div>
          }
        </Container>
      </ModalBody>
    </Modal>
  )
}

const LabelTextInfo = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
  color: ${COLORS.BLACK};
  margin-bottom: 0px ;
`
const TextInfo = styled(Label)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.NORMAL_SIZE};
`
const Header = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.TITLE_SIZE};
  color: ${COLORS.PRIMARY_RED};
  padding-left: 15px;
`



// WEBPACK FOOTER //
// ./src/components/leave-request/show-compensate.js